import { isProduction } from '../utils/envHelper';
import { getCountry } from '../utils/pathHelper';

const production = {
  www: {
    GOOGLE_ANALYTICS: 'UA-89236337-11',
  },
  au: {
    GOOGLE_ANALYTICS: 'UA-89236337-21',
  },
  tw: {
    GOOGLE_ANALYTICS: 'UA-89236337-5',
  },
  hk: {
    GOOGLE_ANALYTICS: 'UA-89236337-6',
  },
  jp: {
    GOOGLE_ANALYTICS: 'UA-89236337-22',
  },
  cn: {
    GOOGLE_ANALYTICS: 'UA-89236337-14',
  },
};

const devBase = {
  GOOGLE_ANALYTICS: 'UA-89236337-3',
};

const development = {
  www: devBase,
  au: devBase,
  tw: devBase,
  hk: devBase,
  cn: devBase,
  jp: devBase,
};

const trackingAccounts = {
  production,
  development,
};
const env = isProduction() ? 'production' : 'development';

export default trackingAccounts[env][getCountry()];
